import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.css']
})
export class SubHeaderComponent implements OnInit {
  @Input() leftPart: any;
  @Input() centerPart: string;
  @Input() rightPart: string;
  @Input() isCenter: boolean;
  @Input() value: string;
  @Input() pageName: any;
  @Input() subleftPart: string;
  @Input() buttonName: string;
  @Input() buttonDisabled: boolean;
  @Output() saveData: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) { }

  ngOnInit() { }

  buttonClick() {
    this.saveData.emit();
  }

  goToGroup() {
    this.router.navigateByUrl('/groups');
  }
  goBack() {
    this.router.navigateByUrl('/new-group/public-groups');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/sub-header/sub-header.component.ts